import * as complaintTypes from '../types/ComplaintPosition';
import * as complaintPositionsTypes from '../types/ComplaintPositions';
import {INITIAL_STATE} from './state/ComplaintPosition';
import * as pageTypes from '../types/Page';

export default function (state = INITIAL_STATE, action) {
    switch(action.type) {
        case complaintPositionsTypes.COMPLAINT_POSITIONS_ADD_COMPLAINT_POSITION:
            return INITIAL_STATE;
        case complaintTypes.COMPLAINT_POSITION_ADD_FILE:{
            let uploadedFiles = state[action.filesTargetName];
            uploadedFiles.push(action.fileToAdd);
            return {
                ...state,
                [action.filesTargetName]: [...uploadedFiles]
            };
        }
        case complaintTypes.COMPLAINT_POSITION_CHANGE_AMOUNT:
        case complaintTypes.COMPLAINT_POSITION_CHANGE_ARTICLE_SERIAL_NUMBER:
        case complaintTypes.COMPLAINT_POSITION_CHANGE_ARTICLE_PURCHASE_DATE:
        case complaintTypes.COMPLAINT_POSITION_CHANGE_CUSTOMER_REQUEST:
        case complaintTypes.COMPLAINT_POSITION_CHANGE_FAULT_DATE:
        case complaintTypes.COMPLAINT_POSITION_CHANGE_FAULT_DESCRIPTION:
        case complaintTypes.COMPLAINT_POSITION_CHANGE_NOTES:
        case complaintTypes.COMPLAINT_POSITION_CHANGE_FAULT_DISCOVERY_CIRCUMSTANCES:
        case complaintTypes.COMPLAINT_POSITION_CHANGE_INVOICE_QUANTITY:
        case complaintTypes.COMPLAINT_POSITION_CHANGE_PRODUCT:
        case complaintTypes.COMPLAINT_POSITION_CHANGE_QUANTITY_CORRECTIONS_PROPOSAL:
        case complaintTypes.COMPLAINT_POSITION_CHANGE_SALES_DOCUMENT_NUMBER:
        case complaintTypes.COMPLAINT_POSITION_CHANGE_SHIPMENT_DESCRIPTION:
        case complaintTypes.COMPLAINT_POSITION_CHANGE_SHIPPED_QUANTITY:
        case complaintTypes.COMPLAINT_POSITION_CHANGE_TERM_OF_USE:
        case complaintTypes.COMPLAINT_POSITION_CHANGE_DATE_OF_RECEIPT_OF_GOODS:
        case complaintTypes.COMPLAINT_POSITION_CHANGE_COURIER:
        case complaintTypes.COMPLAINT_POSITION_CHANGE_SALES_DOCUMENT_POSITION:
        case complaintTypes.COMPLAINT_POSITION_UPDATE_FIELD:
            return Object.assign({}, state, action.payload);
        case complaintTypes.COMPLAINT_POSITION_FILL_BY_OBJECT:
            return {
                ...state,
                id: action.position.id,
                amount: action.position.amount,
                articleSerialNumber: action.position.articleSerialNumber,
                articlePurchaseDate: action.position.articlePurchaseDate,
                courier: action.position.courier,
                customerRequest: action.position.customerRequest,
                description: action.position.description,
                dateOfReceiptOfGoods: action.position.dateOfReceiptOfGoods,
                faultDate: action.position.faultDate,
                faultDescription: action.position.faultDescription,
                faultDiscoveryCircumstances: action.position.faultDiscoveryCircumstances,
                files: action.position.files,
                invoiceQuantity: action.position.invoiceQuantity,
                product: action.position.product,
                quantityCorrectionsProposal: action.position.quantityCorrectionsProposal,
                salesDocumentNumber: action.position.salesDocumentNumber,
                salesDocumentPosition: action.position.salesDocumentPosition,
                shipmentDescription: action.position.shipmentDescription,
                shippedQuantity: action.position.shippedQuantity,
                termOfUse: action.position.termOfUse,
                waybillNumber: action.position.waybillNumber,
                waybillCourier: action.position.waybillCourier,
            };
        case complaintTypes.ADD_PURCHASE_ADDRESS_TO_COMPLAINT_POSITION:
            return {
                ...state,
                articlePurchaseAddress:action.payload.companyName
            };
        case complaintTypes.COMPLAINT_POSITION_REMOVE_FILE:
            return{
                ...state,
                files: state.files.filter((fileToRemove) => fileToRemove !== action.fileToRemove),
                purchaseProve: state.purchaseProve.filter((fileToRemove) => fileToRemove !== action.fileToRemove)
            };
        case complaintTypes.COMPLAINT_POSITION_DISSMIS_CHANGES:
            return INITIAL_STATE;
        case pageTypes.PAGE_GO_TO_COMPLAINT_PREVIEW_PAGE:
        case pageTypes.PAGE_GO_TO_START_PAGE: 
        case pageTypes.PAGE_GO_TO_CREATE_COMPLAINT_PAGE:
        case pageTypes.PAGE_GO_TO_CREATE_COMPLAINT_PAGE_WITHOUT_CUSTOMER_DATA_CLEAR:
            return {
                ...INITIAL_STATE,
                files : [],
                purchaseProve : []
            };
    }
    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/ComplaintPosition.js